import * as React from 'react'
import { ApolloError } from 'apollo-client'
import { defineMessages, FormattedMessage, MessageDescriptor } from 'react-intl'

type Messages = Record<string, MessageDescriptor>

interface IApolloErrorMessageProps {
  error: ApolloError
  messages?: Messages
}

const messages: Messages = defineMessages({
  'bankid-session-already-in-progress': {
    defaultMessage: 'En BankID-session pågår redan',
    id: 'apollo-error-message.bankid-session-already-in-progress',
  },
  'network-error': {
    defaultMessage: 'Ett nätverksfel har uppstått, kontrollera din anslutning och försök igen',
    id: 'apollo-error-message.network-error',
  },
  'signup-email-mismatch': {
    defaultMessage: 'Det finns redan en användare registrerad på dig eller din e-postadress.',
    id: 'apollo-error-message.email-mismatch',
  },
  'too-many-requests': {
    defaultMessage: 'Sakta ner lite! Du får inte söka så ofta, testa igenom en liten stund.',
    id: 'apollo-error-message.too-many-requests',
  },

  default: {
    defaultMessage: 'Hoppsan! Något gick fel',
    id: 'apollo-error-message.default',
  },
})

function getMessage(error: ApolloError, messageTable: Messages) {
  if (error.networkError) {
    return messageTable['network-error']
  }

  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    return (
      messageTable[error.graphQLErrors[0].extensions && error.graphQLErrors[0].extensions.code] || messageTable.default
    )
  }

  return messageTable.default
}

export default function ApolloErrorMessage(props: IApolloErrorMessageProps) {
  return <FormattedMessage {...getMessage(props.error, Object.assign({}, messages, props.messages))} />
}
